import React, { useMemo } from "react";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { generateColumnsDefaultConfiguration } from "../../../components/dataGrid/columnHelpers";
import { PopoverModal } from "../../../components/popoverModal/PopoverModal";
import { useNavigate } from "react-router-dom";
import { IndicadorEstado } from "../../ContratosCreation/components/IndicadorEstado/IndicadorEstado";
import { min } from "moment";

export function useGestionAsistencialColumns(
  estadosPacienteOptions,
  delegaciones,
  nombreDelegacion,
  idDelegacion,
  allowedWrite
) {
  const navigate = useNavigate();
  const asistencialDetallePath = "/asistencial/gestionAsistencial/detalle";

  const handleClickEdit = (row) => {
    navigate(asistencialDetallePath, {
      state: {
        idEvaluacion: row.contrato,
        idPaciente: row.hc,
        allowedWrite: allowedWrite,
        estadosPacienteOptions: estadosPacienteOptions,
        delegacionesUsuario: delegaciones,
        nombreDelegacion,
        idDelegacion,
      },
    });
  };

  const handleClickView = (row) => {
    navigate(asistencialDetallePath, {
      state: {
        idEvaluacion: row.contrato,
        idPaciente: row.hc,
        allowedWrite: false,
        estadosPacienteOptions: estadosPacienteOptions,
        delegacionesUsuario: delegaciones,
        nombreDelegacion,
        idDelegacion,
      },
    });
  };

  const initialColumns = [
    {
      headerName: "",
      field: "action",
      width: 50,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <PopoverModal>
            <div className="popover-modal-content">
              <div
                aria-hidden='true'
                onClick={() => handleClickView(row)}
                className="item-option clickable-option"
              >
                <VisibilityIcon className="edit-icon" />
                <span className="toggle-action">Ver</span>
              </div>
              {allowedWrite && (<div
                aria-hidden='true'
                onClick={() => handleClickEdit(row)}
                className="item-option clickable-option"
              >
                <EditIcon className="edit-icon" />
                <span className="toggle-action">Editar</span>
              </div>)}
            </div>
          </PopoverModal>
        );
      },
    },
    {
      width: 100,
      field: "contrato",
      headerName: "Contrato",
    },
    {
      width: 100,
      field: "hc",
      headerName: "HC",
    },
    {
      width: 120,
      field: "pacienteSAP",
      headerName: "Paciente SAP",
    },
    {
      minWidth: 190,
      field: "paciente",
      headerName: "Paciente",
    },
    {
      width: 70,
      field: "edad",
      headerName: "Edad",
    },
    {
      width: 130,
      field: "clienteSAP",
      headerName: "Cliente",
    },
    {
      minWidth: 230,
      flex: 230,
      field: "nombreCliente",
      headerName: "Nombre cliente",
    },
    {
      width: 160,
      field: "idPlan",
      headerName: "Plan cuidado",
    },
    {
      flex: 280,
      minWidth: 280,
      field: "nombrePlan",
      headerName: "Nombre plan",
    },
    {
      width: 140,
      field: "fechaDesde",
      headerName: "F. desde",
      type: "date",
    },
    {
      width: 140,
      field: "fechaHasta",
      headerName: "F. hasta",
      type: "date",
    },
    {
      width: 80,
      field: "cx",
      align: "center",
      headerAlign: "center",
      headerName: "C X",
      renderCell: ({ row }) => (
        <IndicadorEstado showIcon={false} type={row.cx ? "success" : "error"} />
      ),
    },
  ];

  const columns = useMemo(
    () => generateColumnsDefaultConfiguration(initialColumns, true),
    [estadosPacienteOptions, nombreDelegacion]
  );

  return columns;
}
